export const ProjectData = [
  {
    id: 1,
    title: "E-Commerce APP",
    description:
      "Ecommerce website built with the MERN stack with React context API for state management ,pure css for style and CRUD operation implemented for the admin to crete,update,edit and delete products",
    tags: ["ReactJs", "NodeJs", "MongoDB", "ExpressJs"],
    forntend: "https://github.com/rakesh468/e-commerce",
    backend: "https://github.com/rakesh468/e-commerce",
    netlify: "https://e-commerce-site-application.herokuapp.com",
    image:
      "https://media.istockphoto.com/photos/shopping-online-concept-shopping-service-on-the-online-web-with-by-picture-id1133980246?k=20&m=1133980246&s=612x612&w=0&h=bwut2YUV7gtnjrv354523xU_9S-TtKQOqGTdiGMsPfs=",
  },
  {
    id: 2,
    title: "Airbnb Clone App",
    description:
      "Airbnb Clone App is made using reactjs and nodejs.CRUD operation implemented for the app.To Create Update,Read and Delete",
    tags: ["ReactJs", "NodeJs", "MongoDB", "ExpressJs"],
    forntend: "https://github.com/rakesh468/Airbnb-App",
    backend: "https://github.com/rakesh468/Airbnb-App",
    netlify: "https://airbnb-clone-application.herokuapp.com",
    image:
      "https://static01.nyt.com/images/2016/07/24/travel/24Getaway-Hotels-vs-Airbnb/24Getaway-Hotels-vs-Airbnb-jumbo.jpg",
  },
  {
    id: 3,
    title: "MOVIES APP",
    description:
      "Simple movie app is made using nodejs and reactjs. CRUD operations implemented for the list of movies, where movies can be deleted, updated, created and read.",
    tags: ["ReactJs", "NodeJs", "MongoDB", "ExpressJs"],
    forntend: "https://github.com/rakesh468/movies-app-application",
    backend: "https://github.com/rakesh468/movies-app-application",
    netlify: "https://movies-app-application.herokuapp.com",
    image:
      "https://www.maketecheasier.com/assets/uploads/2021/04/watch-movies-online-with-friends-parsec.jpg",
  },
  {
    id: 4,
    title: "Dominos APP",
    description:
      "Dominos food order app helps the customer order there foods through the app by addiing there foods to the cart  and payment made through card transaction",
    tags: ["ReactJs", "NodeJs", "MongoDB", "ExpressJs"],
    forntend: "https://github.com/rakesh468/dominos-food-order-app",
    backend: "https://github.com/rakesh468/dominos-food-order-app",
    netlify: "https://dominos-food-order-application.herokuapp.com",
    image:
      "https://files.muzli.space/fcc3398ec5ac30c29f8194f7436ebb4a.jpeg",
  },
];


